import React from 'react';
import { useTranslation } from 'react-i18next';

import { checkSenderEnvelopeDropped } from 'support/helpers/transactions/transactions';
import { SenderEnvelopeDTO } from 'support/types';
import { Alert } from 'components/Display/Alert/Alert';
import { AlertSection } from 'components/Display/Alert/AlertSection';

import { formatDroppedReason } from '../helpers';

type DroppedSenderEnvelopeAlertProps = {
  senderEnvelope?: SenderEnvelopeDTO | null;
};

export function DroppedSenderEnvelopeAlert({ senderEnvelope }: DroppedSenderEnvelopeAlertProps) {
  const { t } = useTranslation();
  const isSenderEnvelopeDropped = checkSenderEnvelopeDropped(senderEnvelope);

  if (!isSenderEnvelopeDropped) {
    return null;
  }

  const droppedReasons = senderEnvelope?.droppedErrorReasons;

  return (
    <Alert withoutIcon fullWidth severity="neutral">
      {droppedReasons?.length ? (
        droppedReasons.map((context, index) => {
          const formatted = formatDroppedReason(context, t);

          return (
            <React.Fragment key={index}>
              <AlertSection severity="neutral" title={formatted.header}>
                {formatted.content}
              </AlertSection>
              {formatted.howToFix && (
                <AlertSection severity="neutral" title={t('transactions:show.sections.errors.card.howToFix')}>
                  {formatted.howToFix}
                </AlertSection>
              )}
            </React.Fragment>
          );
        })
      ) : (
        <AlertSection severity="neutral" title={t('transactions:show.sections.errors.alert.messageDropped')} />
      )}
    </Alert>
  );
}
